import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SaveFormService {

  constructor() {
  }

  initFormLocalStorage() {
    localStorage.setItem('form', '')
    localStorage['form'] = JSON.stringify({
      personalData: {surname: '', firstname: '', lastname: '', phone: ''},
      companyData: {companyName: '', phone: '', email: '', bin: '', type: ''},
      companyAddress: {index: '', city: '', area: '', street: '', house: '', office: ''},
      products: {productList: ''},
      agreement: {comment: ''}
    });
  }

  getFormData() {
    return JSON.parse(localStorage['form'])
  }

  savePersonalData(
    surname: string,
    firstname: string,
    lastname: string,
    phone: string
  ) {
    const form = this.getFormData()
    form.personalData.surname = surname
    form.personalData.firstname = firstname
    form.personalData.lastname = lastname
    form.personalData.phone = phone
    localStorage['form'] = JSON.stringify(form)
  }

  saveCompanyData(
    companyName: string,
    phone: string,
    email: string,
    bin: string,
    type: string
  ) {
    const form = this.getFormData()
    form.companyData.companyName = companyName
    form.companyData.phone = phone
    form.companyData.email = email
    form.companyData.bin = bin
    form.companyData.type = type
    localStorage['form'] = JSON.stringify(form)
  }

  saveCompanyAddress(
    index: string,
    city: string,
    area: string,
    street: string,
    house: string,
    office: string
  ) {
    const form = this.getFormData()
    form.companyAddress.index = index
    form.companyAddress.city = city
    form.companyAddress.area = area
    form.companyAddress.street = street
    form.companyAddress.house = house
    form.companyAddress.office = office
    localStorage['form'] = JSON.stringify(form)
  }

  saveProducts(productList: string) {
    const form = this.getFormData()
    form.products.productList = productList
    localStorage['form'] = JSON.stringify(form)
  }

  saveComment(comment: string) {
    const form = this.getFormData()
    form.agreement.comment = comment
    localStorage['form'] = JSON.stringify(form)
  }

}
